<template>
    <div v-if="showStep" class="step-card-wrapper">
        <generic-step-card
            :title="stepTitle"
            :current-step-name="currentStepName"
            :step="step"
            :is-preview="isPreview"
            :is-brief-accepted="isBriefAccepted"
            :is-brief-editable="isBriefEditable"
            :brief="brief"
            :sub-title="subtitle"
        />
    </div>
</template>

<script>
    import GenericStepCard from '../GenericStepCard';
    import {NAME_BRAND_ASSETS} from '../../../../../constants/activation-brief-steps';
    import StepCardViewMixin from '../mixins/StepCardViewMixin';
    import {BRAND_ASSET_FILE_TYPE} from '../../../../../constants/activation-files';
    import {getActivationFiles} from '../../../../../helpers/activations/activation-files';
    import {pluralize} from '../../../../../helpers/string-helpers';

    export default {
        name:       'BrandAssetsStepCardView',
        components: {
            GenericStepCard,
        },
        mixins: [
            StepCardViewMixin,
        ],
        computed: {
            stepName() {
                return NAME_BRAND_ASSETS;
            },
            subtitle() {
                const fileCount = getActivationFiles(this.brief, BRAND_ASSET_FILE_TYPE).length;
                return `${fileCount} ${pluralize(fileCount, 'asset')} available`;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .step-card-wrapper {
        margin-bottom: $g-spacing-5;
    }
</style>
